import { render, staticRenderFns } from "./AiPhraseTool.vue?vue&type=template&id=79f72c6c&scoped=true&"
import script from "./AiPhraseTool.vue?vue&type=script&lang=ts&"
export * from "./AiPhraseTool.vue?vue&type=script&lang=ts&"
import style0 from "./AiPhraseTool.vue?vue&type=style&index=0&id=79f72c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f72c6c",
  null
  
)

export default component.exports